import ClientList from './ClientList'
import ClientWelcome from './ClientWelcome'
import ClientCreate from './ClientCreate'

export default {
  ClientList,
  ClientWelcome,
  ClientCreate
}
